/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationSummariesControllerRemoveMutationResponse, ApplicationSummariesControllerRemovePathParams, ApplicationSummariesControllerRemove401, ApplicationSummariesControllerRemove403, ApplicationSummariesControllerRemove404 } from "../../models/checklistsController/ApplicationSummariesControllerRemove";

function getApplicationSummariesControllerRemoveUrl(id: ApplicationSummariesControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/checklist-application-summaries/${id}` as const }  
  return res
}

/**
 * @summary Delete a checklist application summary (soft delete)
 * {@link /api/v1/checklist-application-summaries/:id}
 */
export async function applicationSummariesControllerRemove(id: ApplicationSummariesControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ApplicationSummariesControllerRemoveMutationResponse, ResponseErrorConfig<ApplicationSummariesControllerRemove401 | ApplicationSummariesControllerRemove403 | ApplicationSummariesControllerRemove404>, unknown>({ method : "DELETE", url : getApplicationSummariesControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}